function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "LeftBckGnd-01",
  transform: "translate(3 5.543)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1012",
  "data-name": "Path 1012",
  d: "M0,205.964s80.706,26.087,129.619-39.13,144.157-50.987,165.488-41.576c22.552,9.95,42.465,14.861,59.513,16.737,48.415,5.327,92.422-29.953,96.084-78.523,2.733-36.26-16.2-62.127-117.282-62.127H0Z",
  transform: "translate(-3 -4)",
  fill: "#f4f7f8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1013",
  "data-name": "Path 1013",
  d: "M365.216,1033.342s-18.4-74.564-117.948-46.616-139.239-49.786-141.335-73.02c-2.215-24.563-9.117-54.36-17.889-67.047-13.184-19.066-24.54-23.142-42.391-26.9C24.838,815.372,0,824.964,0,837.691v194.021S.08,1027.277,365.216,1033.342Z",
  transform: "translate(-3 -370.565)",
  fill: "#f4f7f8"
}));

var SvgLeftBackground = function SvgLeftBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.95,
    height: 668.319,
    viewBox: "0 0 450.95 668.319",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeftBackground.72257947.svg";
export { ForwardRef as ReactComponent };